:host {
   display: block;
}

.filter-wrapper {
    display: flex;
    flex-direction: column;

    ::slotted(lilu-accordion:last-of-type) {
        border-bottom: 1px solid var(--color-silver);
        display: block;
    }

    ::slotted(#show-results) {
        margin-top: 20px;

        @include breakpointMin("lg") {
            display: none;
        }
    }

    ::slotted(lilu-link) {
        align-self: center;
        margin-top: 30px;

        @include breakpointMin("lg") {
            display: none;
        }
    }
}